export const definirSenhaInitialState = {
  dadosDefSenha: [],
  senhaDefinida: [],
};
